module.exports = __webpack_public_path__ + "static/media/letniy-otdyh.0a37e96e.jpg";